<template>
    <div v-if="!loading" class="caption full-width my-0 pt-1 pb-0 px-0">
        <div class="text-subtitle-2">Set di prove: {{category.name}}</div>
            <!--span v-for="bid in Object.keys(category[op])" :key="bid">
                <span v-if="category[op][bid].cat_type=='multiple' && !category[op][bid].calc_value && category[op][bid].trials.length>0"> 
                    <span class="font-italic pr-2">{{ category[op][bid].label }}:</span>
                    <span v-for="trial of category[op][bid].trials" :key="trial.values_nr">{{trial.values_nr}}, </span>
                </span>
            </span-->
            <div class="pl-4" v-for="op of Object.keys(cat_print)" :key="op">
                <div><span class="text-subtitle-2 font-italic">{{cat_print[op].label}}</span>: 
                    <span class="font-italic" v-if="cat_print[op].calc">valori della normativa</span>
                    <span class="font-italic" v-else>
                        <span class="pr-2" v-for="block of cat_print[op].blocks" :key="block.label">{{block.label}}: {{block.trials}}</span>
                    </span>
                </div>
            </div>
    </div>
</template>
<script>
// import _ from 'lodash'

import { report_type } from "../../utils/common.js"
  

export default {
    components: {},
    props: {
        category_id: {
            type: String,
            required: true
        },
    },
    data(){
        return {
            loading: true,
            category: null,
            op_types: [],
            cat_print: {}
        }
    },
    computed: {
        
    },
    async mounted() {
        this.op_types = report_type
        await this.loadCategory()
    },
    methods: {
        async loadCategory() {
            this.loading = true
            console.log('LOAD Category')
            this.category = await this.$store.state.$pouch.get('masters', this.category_id)
            for ( let op of Object.keys(this.op_types) ) {
                this.cat_print[op] = { 
                    label: this.op_types[op].name,
                    blocks: []
                }
                let calc = true
                for (let bid of Object.keys(this.category[op])) {
                    calc = calc & this.category[op][bid].calc_value
                    if (this.category[op][bid].cat_type=='multiple' && !this.category[op][bid].calc_value && this.category[op][bid].trials.length>0) {
                        let b = {label:this.category[op][bid].label, trials:''} 
                        for (let trial of this.category[op][bid].trials) {
                            b.trials += trial.values_nr+', '
                        }
                        b.trials = b.trials.slice(0, -2)
                        this.cat_print[op].blocks.push(b)
                    }
                }
                this.cat_print[op].calc = calc
                console.log("+++++++++++++++", this.cat_print[op])
                
            }
            this.loading = false
        }
    },
    
    
}

</script>